import { useCallback } from "react";

import { useRequestWithFeedback } from "../../../composites";
import { useObjectMemo } from "../../../hooks";

import { API } from "./api";
import { useUser } from "./hooks";

import type { OverrideRunProps } from "../../../composites";

export const useUpdateUserMetadata = () => {
  const { id } = useUser() || {};
  const { send, loading } = useRequestWithFeedback<API.User["metadata"]>();

  const editUserMetadata = useCallback(
    (
      metadata: Parameters<typeof API.editUserMetadata>[1],
      overrideRunProps?: OverrideRunProps<API.User["metadata"]>,
    ) => {
      if (id) {
        send({
          action: API.editUserMetadata(id, metadata),
          ...overrideRunProps,
        });
      }
    },
    [id, send],
  );

  return useObjectMemo({ editUserMetadata, loading });
};

export const useAcceptTransactionalSmsDisclosure = () => {
  const { send, loading } = useRequestWithFeedback<null>();

  const acceptTransactionalSmsDisclosure = useCallback(
    (overrideRunProps?: OverrideRunProps<null>) => {
      send({
        action: API.acceptTransactionalSmsDisclosure(),
        ...overrideRunProps,
      });
    },
    [send],
  );

  return useObjectMemo({ acceptTransactionalSmsDisclosure, loading });
};
